import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEidsivaIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 184,
	height: 150,
	viewBox: "-50 -55 276 225",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 11.0834C0 4.60772 4.82566 0 11.0834 0C17.3724 0 22.1669 4.60772 22.1669 11.0834C22.1669 17.5591 17.3412 22.1669 11.0834 22.1669C4.82566 22.198 0 17.5903 0 11.0834Z",
			fill: "#101820"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.573 138.917C80.573 145.392 85.3987 150 91.6564 150C97.9454 150 102.74 145.392 102.74 138.917C102.74 132.441 97.9142 127.833 91.6564 127.833C85.3987 127.833 80.573 132.41 80.573 138.917Z",
			fill: "#101820"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0423 60.959H114.882V47.9141H72.0423V17.4035H123.474V4.3587H58.0012V106.258H125.342V93.213H72.0423V60.959Z",
			fill: "#101820"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.229 106.133C178.518 106.133 183.313 101.526 183.313 95.0499C183.313 88.5741 178.518 83.9664 172.229 83.9664C165.94 83.9664 161.146 88.5741 161.146 95.0499C161.146 101.526 165.972 106.133 172.229 106.133Z",
			fill: "#101820"
		})
	]
});
export default SvgEidsivaIcon;
